import { render, staticRenderFns } from "./CheerLifeFooter.vue?vue&type=template&id=62b0b5f2&scoped=true&"
import script from "./CheerLifeFooter.vue?vue&type=script&lang=js&"
export * from "./CheerLifeFooter.vue?vue&type=script&lang=js&"
import style0 from "./CheerLifeFooter.vue?vue&type=style&index=0&id=62b0b5f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b0b5f2",
  null
  
)

export default component.exports